import React, { useContext } from 'react';
import { KpiOverviewEventInjectContext } from '../../contexts/KpiOverviewEventInjectContext';

export interface IKpiOverviewEventDataBridgeProps {
  style?: React.CSSProperties;
  className?: string;
  type?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * KPI 总览：无请求的「EventService 兼容层」。
 * 从 KpiOverViewFIlter 提供的 Context 读取 eventData/loading，并对唯一子节点 cloneElement 注入，
 * 与 EventService 注入字段保持一致。
 */
const KpiOverviewEventDataBridge: React.FC<IKpiOverviewEventDataBridgeProps> = (
  props,
) => {
  const { style, className, children, ...resetProps } = props || {};
  const { eventData, loading } = useContext(KpiOverviewEventInjectContext);

  return (
    <div className={className} style={style}>
      {React.Children.map(children, (child: React.ReactNode) => {
        if (!React.isValidElement(child)) {
          return child;
        }
        const injectedProps: Record<string, unknown> = {
          ...resetProps,
          eventData,
          loading,
          state: {},
        };
        return React.cloneElement(child, injectedProps);
      })}
    </div>
  );
};

export default KpiOverviewEventDataBridge;
